import React from "react";
import { getDate } from "utils/formatDate";
const DanhSachCuaHangTableRows = ({
  list,
  pageIndex,
  pageSize,
  btnSuaCuaHangClick,
  RoleSuaCuaHang,
}) => {
  return list.List.map((item, index) => {
    return (
      <div
        className="custom-table-row"
        key={"item" + index}
        style={{ minHeight: "62px" }}
      >
        <div className="custom-table-cell flex-basis-5 flex-basis-5-sm disk-mobile ">
          <span className="mobile-column-name color7-bold">STT</span>
          <div className="center-wrapper">
            <p className="text-center color7">
              {(pageIndex - 1) * pageSize + index + 1}
            </p>
          </div>
        </div>
        <div className="custom-table-cell flex-basis-20 flex-basis-20-sm text-center">
          <span className="mobile-column-name color7-bold">Mã cửa hàng</span>
          <div className="center-wrapper color7">{item.Code}</div>
        </div>
        <div className="custom-table-cell  flex-basis-15 flex-basis-15-sm  text-center">
          <span className="mobile-column-name color7-bold">Tên cửa hàng</span>
          <div className="center-wrapper color7" title={item.Name}>
            {item.Name}
          </div>
        </div>
        <div className="custom-table-cell  flex-basis-15 flex-basis-15-sm">
          <span className="mobile-column-name color7-bold">Điện thoại</span>
          <div className="center-wrapper color7">
            {item.Phone?.split(";")[0]}
          </div>
        </div>
        <div className="custom-table-cell flex-basis-15 flex-basis-15-sm">
          <span className="mobile-column-name color7-bold">Địa chỉ</span>
          <div className="center-wrapper color7" title={item.Address}>
            {item.Address}
          </div>
        </div>
        <div className="custom-table-cell flex-basis-13 flex-basis-13-sm">
          <span className="mobile-column-name color7-bold">Ngày tạo</span>
          <div className="center-wrapper color7">
            {getDate(item.BirthDayDaiDien)}
          </div>
        </div>
        <div className="custom-table-cell flex-basis-10 flex-basis-10-sm">
          <span className="mobile-column-name color7-bold">Trạng thái</span>
          <div
            className="center-wrapper"
            style={
              item.Status === 1
                ? {
                    padding: "6px",
                    borderRadius: "5px",
                    color: "#00B699",
                  }
                : {
                    padding: "6px",
                    borderRadius: "5px",
                    color: "#FF5C00",
                  }
            }
          >
            {item.Status === 0
              ? "Tạm ngưng"
              : item.Status !== 2
                ? "Đang hoạt động"
                : "Khóa"}
          </div>
        </div>
        <div className="custom-table-cell flex-basis-7 flex-basis-7-sm">
          <span className="mobile-column-name color7-bold">Thao tác</span>
          <div className="center-wrapper">
            {RoleSuaCuaHang && item.Status !== 2 && (
              <>
                <a
                  className="iconTableMorman"
                  title="Sửa"
                  onClick={() => btnSuaCuaHangClick(item)}
                >
                  <img src="/app-assets/images/icon-edit-v2.png" />
                </a>
              </>
            )}
          </div>
        </div>
      </div>
    );
  });
};
const DanhSachCuaHangTable = ({
  list,
  pageIndex,
  pageSize,
  btnSuaCuaHangClick,
  RoleSuaCuaHang,
}) => {
  // console.log("Data table: ", list)
  if (!list || list.List.length === 0) {
    return (
      <div className="custom-table-row">
        <div
          className="custom-table-cell text-center red"
          style={{ width: "100%" }}
        >
          Không có dữ liệu
        </div>
      </div>
    );
  }
  return (
    <div className="Left808x200 Table-main-new css-table-ds">
      <div className="table-mobile sticky-table-bh2 table-mobile-hover">
        <div className="custom-table-wrapper" style={{ overflowX: "auto" }}>
          <div className="table-headers">
            <div className="custom-table-header flex-basis-5 flex-basis-5-sm text-center">
              <p className="color-do-bold">
                STT
                <br />[{list.iTotal === 0 ? 0 : list.iTotal}]
              </p>
            </div>
            <div className="custom-table-header flex-basis-20 flex-basis-20-sm  text-center">
              <p>Mã cửa hàng</p>
            </div>
            <div className="custom-table-header flex-basis-15 flex-basis-15-sm  text-center">
              <p>Tên cửa hàng</p>
            </div>
            <div className="custom-table-header flex-basis-15 flex-basis-15-sm ">
              <p>Điện thoại</p>
            </div>
            <div className="custom-table-header flex-basis-15 flex-basis-15-sm">
              <p>Địa chỉ</p>
            </div>
            <div className="custom-table-header flex-basis-13 flex-basis-13-sm">
              <p>Ngày tạo</p>
            </div>
            <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
              <p>Trạng thái</p>
            </div>
            <div className="custom-table-header flex-basis-7 flex-basis-7-sm">
              <p>Thao tác</p>
            </div>
          </div>
          <div className="custom-table-body">
            <DanhSachCuaHangTableRows
              list={list}
              pageIndex={pageIndex}
              pageSize={pageSize}
              btnSuaCuaHangClick={btnSuaCuaHangClick}
              RoleSuaCuaHang={RoleSuaCuaHang}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DanhSachCuaHangTable;
